/**
 * Referral tracking — captura ?ref=CODIGO da URL e persiste no localStorage
 * por 30 dias. Usado pelo módulo Comercial / Afiliados para atribuir vendas.
 */

const STORAGE_KEY = "vp_referral_code";
const STORAGE_EXPIRES_AT = "vp_referral_expires_at";
const TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 dias

export function captureReferralFromUrl(): string | null {
  if (typeof window === "undefined") return null;
  try {
    const url = new URL(window.location.href);
    const ref = url.searchParams.get("ref");
    if (!ref) return getReferralCode();
    const code = ref.toUpperCase().trim();
    if (!code || code.length > 64) return getReferralCode();
    localStorage.setItem(STORAGE_KEY, code);
    localStorage.setItem(STORAGE_EXPIRES_AT, String(Date.now() + TTL_MS));
    return code;
  } catch {
    return null;
  }
}

export function getReferralCode(): string | null {
  if (typeof window === "undefined") return null;
  try {
    const code = localStorage.getItem(STORAGE_KEY);
    if (!code) return null;
    const expiresAt = Number(localStorage.getItem(STORAGE_EXPIRES_AT) || 0);
    if (expiresAt && Date.now() > expiresAt) {
      clearReferralCode();
      return null;
    }
    return code;
  } catch {
    return null;
  }
}

export function clearReferralCode(): void {
  if (typeof window === "undefined") return;
  try {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(STORAGE_EXPIRES_AT);
  } catch {
    /* noop */
  }
}
